import { types, applySnapshot, flow } from "mobx-state-tree";

import { URL_API } from "./globals";
import { set } from "mobx";

const Team = types.model("Team", {
  uuid: types.identifier,
  name: types.string,
  code: types.string,
});

const Region = types.model({
  uuid: types.identifier,
  name: types.optional(types.string, ""),
});

const SubTeam = types.model("SubTeam", {
  uuid: types.identifier,
  name: types.string,
  code: types.string,
});

const Client = types.model("Client", {
  uuid: types.identifier,
  name: types.string,
  code: types.string,
  active: types.optional(types.boolean, false),
});

const Kind = types.model("Kind", {
  uuid: types.identifier,
  name: types.string,
  code: types.string,
});

const Employee = types
  .model("Employee", {
    uuid: types.identifier,
    name: types.string,
    code: types.string,
    category: types.string,
    login: types.string,
    password: types.string,
    team: types.maybeNull(
      types.reference(Team, {
        onInvalidated(ev) {
          ev.removeRef();
        },
      })
    ),
    subteam: types.maybeNull(
      types.reference(SubTeam, {
        onInvalidated(ev) {
          ev.removeRef();
        },
      })
    ),
  })
  .actions((self) => ({
    set(row) {
      applySnapshot(self, row);
    },
    setFetch: flow(function* () {
      try {
        yield fetch(`${URL_API}/api/setemployee`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            data: { employee: self },
          }),
        });
      } catch (error) {
        console.error("Ошибка:", error);
      }
    }),
  }));

const Outlet = types
  .model("Outlet", {
    uuid: types.identifier,
    name: types.string,
    code: types.string,
    code_outlet: types.string,
    client: types.reference(Client),
    longitude: types.number,
    latitude: types.number,
    merchandiser: types.maybeNull(
      types.reference(Employee, {
        onInvalidated(ev) {
          ev.removeRef();
        },
      })
    ),
    active: types.optional(types.boolean, false),
    monday: types.boolean,
    tuesday: types.boolean,
    wednesday: types.boolean,
    thursday: types.boolean,
    friday: types.boolean,
    saturday: types.boolean,
    sunday: types.boolean,
    mod: types.optional(types.boolean, false),
    region: types.maybeNull(
      types.reference(Region, {
        onInvalidated(ev) {
          ev.removeRef();
        },
      })
    ),
  })
  .actions((self) => ({
    setDay(day, value) {
      self.mod = true;
      self[day] = value;
    },
    setLocation(latitude, longitude) {
      self.longitude = longitude;
      self.latitude = latitude;
      self.saveLocation();
    },
    saveLocation: flow(function* () {
      try {
        yield fetch(`${URL_API}/api/savelocation`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            data: {
              uuid: self.uuid,
              longitude: self.longitude,
              latitude: self.latitude,
            },
          }),
        });
      } catch (error) {
        console.error("Ошибка:", error);
      }
    }),
  }));

const Product = types
  .model("Product", {
    uuid: types.identifier,
    name: types.string,
    code: types.string,
    artikel: types.string,
    top: types.boolean,
  })
  .actions((self) => ({
    set(row) {
      self.code = row.code;
      self.artikel = row.artikel;
    },
  }));

const ReportMerch = types.model("ReportMerch", {
  team: types.maybeNull(types.reference(Team)),
  merch: types.maybeNull(types.reference(Employee)),
  category: types.string,
  date: types.string,
  total_hours: types.number,
  total_hours_work: types.number,
  total_visits_add: types.number,
  total_visits: types.number,
  total_visits_all: types.number,
  total_days_all: types.number,
  total_days: types.number,
  total_outlet_all: types.number,
  total_outlet: types.number,
});

const ReportAmountOutlets = types.model("ReportAmountOutlets", {
  uuid: types.optional(types.string, ""),
  outlet: types.optional(types.string, ""),
  client: types.optional(types.string, ""),
  amount: types.optional(types.number, 0),
});

export {
  Client,
  Outlet,
  Product,
  Employee,
  Team,
  SubTeam,
  ReportMerch,
  Kind,
  ReportAmountOutlets,
  Region,
};
